<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 0L15.3803 8.35556L24 9.12593L17.4648 15.1111L19.4366 24L12 19.2593L4.56338 24L6.53521 15.1111L0 9.12593L8.61972 8.35556L12 0ZM13.9847 10.2388L12 5.333V16.8874L16.438 19.716L15.2621 14.4164L19.305 10.714L13.9847 10.2388Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'StarHalfFilledIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
